<template>
  <div class="mall">
    <div class="sheet">
      <div class="badge">❤ {{ $t('shop.brand') }}</div>

      <div class="hero">
        <van-swipe :autoplay="3800" indicator-color="#fff">
          <van-swipe-item v-for="(item, index) in swipeList" :key="'b' + index" @click="goBooking">
            <img :src="item.pic" alt="" @error="onSwipeError($event, index)">
            <div class="hero-mask">
              <div class="kicker">{{ $t('shop.kicker') }}</div>
              <div class="hero-title">{{ item.title || $t('shop.hero_title') }}</div>
              <div class="hero-sub">❤ {{ $t('shop.hero_sub') }}</div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>

      <div class="intro">
        <p>❤ {{ $t('shop.tag') }}</p>
        <div class="vals">{{ $t('shop.values') }}</div>
      </div>

      <div class="promo-img" @click="goBooking">
        <img src="/img/shangchang/banner.jpg" alt="">
      </div>
      <div class="promo" v-for="item in promoList" :key="'p' + item.id" @click="goBooking">
        <img :src="item.pic" alt="">
      </div>

      <div class="cats">
        <div class="cat" v-for="c in catGrid" :key="c.code" @click="jumpCat(c.id)">
          <div class="cat-icon">
            <img :src="'/img/shangchang/icons/i' + c.sprite + '.png'" alt="">
          </div>
          <div class="cat-name">{{ catLabel(c) }}</div>
        </div>
      </div>

      <div class="mid" @click="goBooking">
        <img src="/img/shangchang/banner2.jpg" alt="">
      </div>
      <div class="mid" v-for="item in midList" :key="'m' + item.id" @click="goBooking">
        <img :src="item.pic" alt="">
      </div>

      <div class="sec" v-for="sec in shelfList" :id="'cat-' + sec.id" :key="sec.id">
        <div class="sec-head">{{ sec.icon }} {{ $t(sec.titleKey) }}</div>
        <div class="goods cols5 onerow">
          <div class="g" v-for="g in sec.goods" :key="g.id" @click="goBooking">
            <div class="g-top" v-if="sec.showTopPrice && g.price">₩{{ won(g.price) }}</div>
            <div class="g-pic">
              <span class="g-tag" v-if="g.tag">{{ $t('shop.' + g.tag) }}</span>
              <img :src="g.pic" alt="">
            </div>
            <div class="g-name">{{ $t('shop.' + g.id) }}</div>
            <div class="g-range">{{ priceLine(g) }}</div>
            <div class="g-origin" v-if="g.origin">₩{{ won(g.origin) }}</div>
          </div>
        </div>
      </div>

      <div class="sec" v-for="sec in sections" :id="'cat-' + sec.id" :key="'adm-' + sec.id">
        <div class="sec-head">|| {{ catLabel(sec) }} ||</div>
        <div class="goods">
          <div class="g" v-for="g in sec.goods" :key="g.id" @click="goBooking">
            <div class="g-pic">
              <img :src="g.pic" alt="">
              <span class="hot" v-if="Number(g.hot) === 1">HOT</span>
            </div>
            <div class="g-body">
              <div class="g-name">{{ g.name }}</div>
              <div class="g-price">
                <b>₩{{ g.price }}</b>
                <s v-if="showOrigin(g)">₩{{ g.origin_price }}</s>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="sec">
        <div class="sec-head light">{{ $t('shop.articles') }}</div>
        <div class="article" v-for="n in 6" :key="'h' + n" @click="goBooking">
          <img :src="'/img/shangchang/foot/happy' + n + '.jpg'" alt="">
        </div>
      </div>

      <div class="sec">
        <div class="sec-head light">{{ $t('shop.brands') }}</div>
        <div class="brands">
          <div class="brand" v-for="n in 6" :key="'br' + n" @click="goBooking">
            <img :src="'/img/shangchang/foot/brand' + n + '.webp'" alt="">
          </div>
        </div>
      </div>

      <div class="trust">
        <div>
          <div class="t-ico">
            <svg viewBox="0 0 48 48" aria-hidden="true"><path d="M8 28h4l4-12h18l5 12h3v10h-4a4 4 0 01-8 0H20a4 4 0 01-8 0H8V28z" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/><circle cx="16" cy="38" r="3" fill="none" stroke="currentColor" stroke-width="3"/><circle cx="32" cy="38" r="3" fill="none" stroke="currentColor" stroke-width="3"/></svg>
          </div>
          <div class="t-name">{{ $t('shop.fast') }}</div>
          <div class="t-sub">{{ $t('shop.fast_sub') }}</div>
        </div>
        <div>
          <div class="t-ico">
            <svg viewBox="0 0 48 48" aria-hidden="true"><path d="M8 22L24 10l16 12v18H8V22z" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/><path d="M18 40V28h12v12" fill="none" stroke="currentColor" stroke-width="3"/></svg>
          </div>
          <div class="t-name">{{ $t('shop.store') }}</div>
          <div class="t-sub">{{ $t('shop.store_sub') }}</div>
        </div>
        <div>
          <div class="t-ico">
            <svg viewBox="0 0 48 48" aria-hidden="true"><path d="M8 24c0-10 8-16 16-16s16 6 16 16-7 20-16 20c-3 0-6-.6-8-1.6L8 44l2-8C8.8 33 8 28.5 8 24z" fill="none" stroke="currentColor" stroke-width="3"/><path d="M17 24c0-4 3.2-7 7-7s7 3 7 7c0 5-7 10-7 10s-7-5-7-10z" fill="none" stroke="currentColor" stroke-width="3"/></svg>
          </div>
          <div class="t-name">{{ $t('shop.pack') }}</div>
          <div class="t-sub">{{ $t('shop.pack_sub') }}</div>
        </div>
        <div>
          <div class="t-ico">
            <svg viewBox="0 0 48 48" aria-hidden="true"><path d="M10 18h28v22H10z" fill="none" stroke="currentColor" stroke-width="3"/><path d="M16 18V12h16v6M32 8l8 8-8 4" fill="none" stroke="currentColor" stroke-width="3" stroke-linejoin="round"/></svg>
          </div>
          <div class="t-name">{{ $t('shop.quality') }}</div>
          <div class="t-sub">{{ $t('shop.quality_sub') }}</div>
        </div>
      </div>

      <div class="links">
        <div class="links-title">{{ $t('shop.info') }}</div>
        <p>{{ $t('shop.about') }}</p>
        <p>{{ $t('shop.terms') }}</p>
        <p>{{ $t('shop.privacy') }}</p>
        <p>{{ $t('shop.guide') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      banners: [],
      categories: [],
      sections: [],
      defaultSwipes: [
        { id: -1, pic: '/img/shangchang/swipe1.jpg', title: '' },
        { id: -2, pic: '/img/shangchang/swipe2.jpg', title: '' },
        { id: -4, pic: '/img/shangchang/swipe4.jpg', title: '' },
        { id: -5, pic: '/img/shangchang/swipe5.jpg', title: '' },
        { id: -6, pic: '/img/shangchang/swipe6.jpg', title: '' },
      ],
    };
  },
  computed: {
    swipeList() {
      const list = this.banners.filter((b) => Number(b.type) === 1 && b.pic);
      if (list.length) return list;
      return this.defaultSwipes;
    },
    promoList() {
      return this.banners.filter((b) => Number(b.type) === 2 && b.pic);
    },
    midList() {
      return this.banners.filter((b) => Number(b.type) === 3 && b.pic);
    },
    articleList() {
      return this.banners.filter((b) => Number(b.type) === 4 && b.pic);
    },
    brandList() {
      return this.banners.filter((b) => Number(b.type) === 5 && b.pic);
    },
    packGoods() {
      return [
        { id: 'p1', pic: '/img/shangchang/pack/p1.webp', price: '6916', min: '7740', max: '33852', origin: '40768' },
        { id: 'p2', pic: '/img/shangchang/pack/p2.webp', price: '6916', min: '27291', max: '35945', origin: '42864' },
        { id: 'p3', pic: '/img/shangchang/pack/p3.webp', price: '6275', min: '20740', max: '20800', origin: '' },
        { id: 'p4', pic: '/img/shangchang/pack/p4.webp', price: '2737', min: '10100', max: '16000', origin: '' },
        { id: 'p5', pic: '/img/shangchang/pack/p5.webp', price: '13600', min: '15015', max: '18515', origin: '' },
        { id: 'p6', pic: '/img/shangchang/pack/p6.webp', price: '10053', min: '10053', max: '10053', origin: '' },
        { id: 'p7', pic: '/img/shangchang/pack/p7.webp', price: '8099', min: '8099', max: '8099', origin: '' },
        { id: 'p8', pic: '/img/shangchang/pack/p8.webp', price: '4005', min: '4005', max: '4702', origin: '' },
        { id: 'p9', pic: '/img/shangchang/pack/p9.webp', price: '24110', min: '24110', max: '24110', origin: '' },
        { id: 'p10', pic: '/img/shangchang/pack/p10.webp', price: '12285', min: '12285', max: '12885', origin: '' },
        { id: 'p11', pic: '/img/shangchang/pack/p11.webp', price: '55451', min: '55451', max: '55451', origin: '' },
        { id: 'p12', pic: '/img/shangchang/pack/p12.webp', price: '20848', min: '20848', max: '20848', origin: '' },
        { id: 'p13', pic: '/img/shangchang/pack/p13.webp', price: '3178', min: '3178', max: '3178', origin: '' },
        { id: 'p14', pic: '/img/shangchang/pack/p14.webp', price: '10635', min: '10635', max: '20200', origin: '' },
        { id: 'p15', pic: '/img/shangchang/pack/p15.webp', price: '24570', min: '24570', max: '24570', origin: '' },
        { id: 'p16', pic: '/img/shangchang/pack/p16.webp', price: '13650', min: '13650', max: '16500', origin: '' },
        { id: 'p17', pic: '/img/shangchang/pack/p17.webp', price: '29120', min: '29120', max: '30900', origin: '' },
        { id: 'p18', pic: '/img/shangchang/pack/p18.webp', price: '17445', min: '17445', max: '17845', origin: '' },
      ];
    },
    menGoods() {
      return [
        { id: 'n1', pic: '/img/shangchang/men/n1.webp', tag: 'men_t1', min: '12103', max: '27291', origin: '35247' },
        { id: 'n2', pic: '/img/shangchang/men/n2.webp', tag: 'men_t2', min: '12103', max: '37310', origin: '50232' },
        { id: 'n5', pic: '/img/shangchang/men/n5.webp', tag: 'men_t3', min: '9103', max: '15288', origin: '20111' },
        { id: 'n6', pic: '/img/shangchang/men/n6.webp', tag: 'men_t4', min: '10192', max: '10192', origin: '14833' },
        { id: 'n8', pic: '/img/shangchang/men/n8.webp', tag: 'men_hot', min: '9555', max: '9555', origin: '14287' },
        { id: 'n9', pic: '/img/shangchang/men/n9.webp', tag: 'men_hot', min: '20930', max: '20930', origin: '22113' },
        { id: 'n10', pic: '/img/shangchang/men/n10.webp', tag: 'men_hot', min: '7098', max: '7098', origin: '7449' },
        { id: 'n11', pic: '/img/shangchang/men/n11.webp', tag: 'men_hot', min: '9555', max: '9555', origin: '10829' },
      ];
    },
    womenGoods() {
      return [
        { id: 'vx', pic: '/img/shangchang/women/x.webp', tag: 'women_t1', min: '11102', max: '14924', origin: '14924' },
        { id: 'v2', pic: '/img/shangchang/women/v2.webp', tag: 'women_t2', min: '5187', max: '9828', origin: '10820' },
        { id: 'v3', pic: '/img/shangchang/women/v3.webp', tag: 'women_t3', min: '9009', max: '9009', origin: '10556' },
        { id: 'v6', pic: '/img/shangchang/women/v6.webp', tag: 'women_t4', min: '8008', max: '8008', origin: '11284' },
        { id: 'v9', pic: '/img/shangchang/women/v9.webp', tag: 'women_hot', min: '4095', max: '4095', origin: '' },
      ];
    },
    coupleGoods() {
      return [
        { id: 'b1', pic: '/img/shangchang/couple/b1.webp', tag: 'couple_t1', min: '6279', max: '12558', origin: '15470' },
        { id: 'b7', pic: '/img/shangchang/couple/b7.webp', tag: 'couple_t2', min: '7735', max: '7735', origin: '10010' },
        { id: 'b3', pic: '/img/shangchang/couple/b3.webp', tag: 'couple_t3', min: '6279', max: '12558', origin: '15470' },
        { id: 'b6', pic: '/img/shangchang/couple/b6.webp', tag: 'couple_t4', min: '3276', max: '3276', origin: '4641' },
        { id: 'b5', pic: '/img/shangchang/couple/b5.webp', tag: 'couple_hot', min: '14459', max: '14459', origin: '18064' },
        { id: 'b8', pic: '/img/shangchang/couple/b8.webp', tag: 'couple_hot', min: '1356', max: '1356', origin: '' },
      ];
    },
    gayGoods() {
      return [
        { id: 'gx', pic: '/img/shangchang/gay/x.webp', tag: 'gay_t1', min: '13013', max: '15925', origin: '17836' },
        { id: 'g2', pic: '/img/shangchang/gay/g2.webp', tag: 'gay_t2', min: '12740', max: '12740', origin: '16835' },
        { id: 'g3', pic: '/img/shangchang/gay/g3.webp', tag: 'gay_t3', min: '10647', max: '10647', origin: '14287' },
        { id: 'g4', pic: '/img/shangchang/gay/g4.webp', tag: 'gay_t4', min: '4459', max: '4459', origin: '8918' },
        { id: 'g8', pic: '/img/shangchang/gay/g8.webp', tag: 'gay_hot', min: '6916', max: '6916', origin: '9828' },
        { id: 'g5', pic: '/img/shangchang/gay/g5.webp', tag: 'gay_hot', min: '2457', max: '2457', origin: '3731' },
      ];
    },
    lesGoods() {
      return [
        { id: 'l1', pic: '/img/shangchang/les/l1.webp', tag: 'les_t1', min: '27118', max: '30030', origin: '35763' },
        { id: 'l2', pic: '/img/shangchang/les/l2.webp', tag: 'les_t2', min: '18655', max: '20566', origin: '24385' },
        { id: 'l3', pic: '/img/shangchang/les/l3.webp', tag: 'les_t3', min: '15379', max: '15379', origin: '20657' },
        { id: 'l5', pic: '/img/shangchang/les/l5.webp', tag: 'les_t4', min: '12240', max: '12240', origin: '16198' },
        { id: 'l6', pic: '/img/shangchang/les/l6.webp', tag: 'les_hot', min: '3549', max: '3549', origin: '4732' },
        { id: 'l7', pic: '/img/shangchang/les/l7.webp', tag: 'les_hot', min: '8190', max: '8190', origin: '9828' },
        { id: 'l9', pic: '/img/shangchang/les/l9.webp', tag: 'les_hot', min: '10010', max: '10010', origin: '13634' },
      ];
    },
    shelfList() {
      return [
        { id: 'pack', icon: '🎁', titleKey: 'shop.pack_title', showTopPrice: true, goods: this.packGoods },
        { id: 'men', icon: '✈️', titleKey: 'shop.men_title', goods: this.menGoods },
        { id: 'women', icon: '🍌', titleKey: 'shop.women_title', goods: this.womenGoods },
        { id: 'couple', icon: '😘', titleKey: 'shop.couple_title', goods: this.coupleGoods },
        { id: 'gay', icon: '💑', titleKey: 'shop.gay_title', goods: this.gayGoods },
        { id: 'les', icon: '💗', titleKey: 'shop.les_title', goods: this.lesGoods },
      ];
    },
    catGrid() {
      const codes = ['condom', 'lube', 'vibe', 'plug', 'cup', 'wand', 'lingerie', 'sm', 'care', 'suction', 'beginner', 'health'];
      const byCode = {};
      this.categories.forEach((c) => {
        if (c && c.code) byCode[c.code] = c;
      });
      return codes.map((code, i) => {
        const row = byCode[code] || { id: 0, code, name: '' };
        return {
          id: row.id || 0,
          code,
          name: row.name || '',
          sprite: i,
        };
      });
    },
  },
  methods: {
    won(n) {
      const s = String(n || '').replace(/[^\d]/g, '');
      if (!s) return '0';
      return s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    priceLine(g) {
      if (g.min && g.max && String(g.min) !== String(g.max)) {
        return '₩' + this.won(g.min) + ' ~ ₩' + this.won(g.max);
      }
      return '₩' + this.won(g.min || g.price);
    },
    catLabel(item) {
      const code = item && item.code ? String(item.code) : '';
      if (!code) return (item && item.name) || '';
      const key = 'shop.cat.' + code;
      const text = this.$t(key);
      return text && text !== key ? text : (item.name || '');
    },
    onSwipeError(e, index) {
      const fallback = this.defaultSwipes[index % this.defaultSwipes.length];
      if (!fallback || !e || !e.target) return;
      if (String(e.target.src).indexOf('/img/shangchang/') >= 0) return;
      e.target.src = fallback.pic;
    },
    isPic(icon) {
      const s = String(icon || '');
      return s.indexOf('http') === 0 || s.indexOf('/') >= 0;
    },
    showOrigin(g) {
      return Number(g.origin_price) > Number(g.price);
    },
    goBooking() {
      this.$router.push('/Booking');
    },
    jumpCat(id) {
      const map = {
        condom: 'men', cup: 'men',
        vibe: 'women', wand: 'women', suction: 'women',
        lube: 'couple', sm: 'couple', care: 'couple',
        plug: 'gay', lingerie: 'les',
        beginner: 'pack', health: 'pack',
      };
      const cat = this.catGrid.find((c) => Number(c.id) === Number(id));
      const target = (cat && map[cat.code]) || id;
      const el = document.getElementById('cat-' + target);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else this.goBooking();
    },
    loadHome() {
      this.$http({ method: 'get', url: 'shop_home' }).then((res) => {
        if (!res || Number(res.code) !== 200 || !res.data) return;
        this.banners = Array.isArray(res.data.banners) ? res.data.banners : [];
        this.categories = Array.isArray(res.data.categories) ? res.data.categories : [];
        this.sections = Array.isArray(res.data.sections) ? res.data.sections : [];
      });
    },
  },
  created() {
    document.title = this.$t('shop.brand');
    this.loadHome();
  },
};
</script>

<style lang="less" scoped>
.mall {
  min-height: 100vh;
  background: #f4e9df;
  padding: 24px 18px 160px;
}
.sheet {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 28px rgba(80, 40, 20, 0.08);
  padding-bottom: 8px;
}
.badge {
  width: 420px;
  margin: 28px auto 18px;
  height: 56px;
  line-height: 56px;
  text-align: center;
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  border-radius: 28px;
  background: linear-gradient(90deg, #ff4d88, #ff2d6f);
}
.hero {
  position: relative;
}
.hero ::v-deep .van-swipe,
.hero ::v-deep .van-swipe-item {
  height: 520px;
}
.hero ::v-deep .van-swipe-item {
  position: relative;
}
.hero img {
  display: block;
  width: 100%;
  height: 520px;
  object-fit: cover;
}
.hero-mask {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 48px 36px 36px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0), rgba(20, 8, 12, 0.72));
  color: #fff;
}
.kicker {
  display: inline-block;
  font-size: 20px;
  letter-spacing: 4px;
  padding: 4px 12px;
  border: 1px solid rgba(255,255,255,.7);
  border-radius: 4px;
  margin-bottom: 12px;
}
.hero-title {
  font-size: 48px;
  font-weight: 800;
  letter-spacing: 2px;
  line-height: 1.2;
}
.hero-sub {
  margin-top: 10px;
  font-size: 28px;
}
.intro {
  padding: 36px 40px 8px;
  text-align: center;
  color: #3b4252;
  font-size: 28px;
  line-height: 1.7;
}
.intro p { margin: 0 0 16px; }
.vals {
  color: #d6336c;
  font-size: 24px;
  font-weight: 600;
}
.promo-img {
  margin: 8px 28px 4px;
}
.promo-img img {
  width: 100%;
  display: block;
}
.promo {
  margin: 8px 28px 4px;
}
.promo img {
  width: 100%;
  display: block;
  border-radius: 12px;
}
.cats {
  display: flex;
  flex-wrap: wrap;
  padding: 12px 8px 20px;
}
.cat {
  width: 25%;
  text-align: center;
  margin: 8px 0 18px;
}
.cat-icon {
  width: 128px;
  height: 128px;
  margin: 0 auto 10px;
}
.cat-icon img {
  width: 100%;
  height: 100%;
  display: block;
}
.cat-name {
  font-size: 22px;
  color: #555;
  padding: 0 6px;
  line-height: 1.3;
}
.mid {
  margin: 4px 0 8px;
}
.mid img {
  width: 100%;
  display: block;
}
.sec {
  padding: 12px 0 8px;
}
.sec-head {
  margin: 16px 28px 22px;
  height: 72px;
  line-height: 72px;
  text-align: center;
  color: #fff;
  font-size: 30px;
  font-weight: 800;
  border-radius: 16px;
  background: linear-gradient(90deg, #ff4d97, #ff2d6f);
}
.sec-head.light {
  background: #efefef;
  color: #e62978;
  font-weight: 800;
}
.goods {
  display: flex;
  flex-wrap: wrap;
  padding: 0 12px;
}
.g {
  width: 33.33%;
  padding: 0 10px 28px;
  box-sizing: border-box;
}
.goods.cols5 {
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
  padding: 0 12px 8px;
}
.goods.cols5::-webkit-scrollbar {
  height: 0;
}
.goods.cols5 .g {
  flex: 0 0 20%;
  width: 20%;
  min-width: 20%;
  max-width: 20%;
  padding: 0 6px 12px;
  scroll-snap-align: start;
}
.goods.cols5.onerow {
  flex-wrap: nowrap;
}
.g-top {
  color: #ff2d6f;
  font-size: 22px;
  font-weight: 800;
  margin-bottom: 6px;
}
.goods.cols5 .g-pic img {
  height: 168px;
  object-fit: contain;
  background: #fff;
}
.g-range {
  color: #ff2d6f;
  font-size: 20px;
  font-weight: 700;
  margin-top: 4px;
}
.g-origin {
  color: #bbb;
  font-size: 20px;
  margin-top: 2px;
}
.goods.cols5 .g-name {
  height: 84px;
  font-size: 20px;
  line-height: 28px;
}
.g-pic {
  position: relative;
  background: #f7f3ef;
  border-radius: 12px;
  overflow: hidden;
}
.g-tag {
  position: absolute;
  top: 8px;
  right: 0;
  z-index: 2;
  background: #ff2d6f;
  color: #fff;
  font-size: 16px;
  line-height: 1.2;
  padding: 6px 10px 6px 12px;
  border-radius: 12px 0 0 12px;
  font-weight: 800;
  max-width: 92%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.g-pic img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  display: block;
}
.hot {
  position: absolute;
  left: 0;
  top: 16px;
  background: #ff2d6f;
  color: #fff;
  font-size: 18px;
  padding: 4px 14px 4px 12px;
  border-radius: 0 12px 12px 0;
  font-weight: 700;
  letter-spacing: 1px;
}
.g-body {
  padding: 12px 4px 0;
}
.g-name {
  font-size: 24px;
  color: #333;
  height: 64px;
  line-height: 32px;
  overflow: hidden;
}
.g-price b {
  color: #ff2d6f;
  font-size: 28px;
  font-weight: 800;
}
.g-price s {
  color: #bbb;
  font-size: 22px;
  margin-left: 8px;
}
.empty {
  text-align: center;
  color: #999;
  padding: 40px 40px 60px;
  font-size: 26px;
}
.article {
  margin: 0 24px 14px;
  border-radius: 16px;
  overflow: hidden;
}
.article img {
  width: 100%;
  display: block;
}
.brands {
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px 8px;
}
.brand {
  width: 50%;
  padding: 6px;
  box-sizing: border-box;
}
.brand img {
  width: 100%;
  height: 280px;
  object-fit: cover;
  border-radius: 12px;
  display: block;
}
.trust {
  display: flex;
  flex-wrap: wrap;
  margin: 8px 12px 8px;
  padding-top: 8px;
  text-align: center;
}
.trust > div {
  width: 50%;
  padding: 28px 16px 24px;
  box-sizing: border-box;
}
.t-ico {
  color: #ff2d6f;
  width: 72px;
  height: 72px;
  margin: 0 auto;
}
.t-ico svg {
  width: 72px;
  height: 72px;
  display: block;
}
.t-name {
  font-weight: 800;
  font-size: 30px;
  margin: 12px 0 10px;
  color: #222;
}
.t-sub {
  color: #444;
  font-size: 22px;
  line-height: 1.45;
  white-space: pre-line;
}
.links {
  margin: 12px 0 0;
  text-align: center;
  padding: 28px 24px 48px;
  color: #888;
  font-size: 24px;
  line-height: 2;
  background: #faf6f2;
}
.links-title {
  color: #c45c7a;
  font-weight: 700;
  margin-bottom: 8px;
}
::v-deep .van-swipe__indicator {
  background: rgba(255,255,255,.45);
}
::v-deep .van-swipe__indicator--active {
  background: #fff;
}
</style>
